const WHATSAPP_URL = "https://wa.me/5547996077227?text=Olá,%20preciso%20de%20orientação%20jurídica%20especializada.";

const handleScroll = (href: string) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function CTA() {
  return (
    <section className="py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20navy%20blue%20minimalist%20legal%20background%20with%20golden%20geometric%20lines%20and%20subtle%20patterns%2C%20deep%20blue%20tones%2C%20sophisticated%20luxury%20texture%2C%20premium%20institutional%20design%2C%20clean%20modern%20aesthetic%2C%20dark%20indigo%20atmosphere%20with%20faint%20light%20streaks%2C%20professional%20corporate%20wallpaper&width=1440&height=600&seq=cta001&orientation=landscape"
          alt="Background CTA"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0A2472]/92" />
        <div
          className="absolute top-0 left-0 w-full h-1"
          style={{ background: "linear-gradient(90deg, transparent, #C8A63A, #E6D18A, #C8A63A, transparent)" }}
        />
        <div
          className="absolute bottom-0 left-0 w-full h-1"
          style={{ background: "linear-gradient(90deg, transparent, #C8A63A, #E6D18A, #C8A63A, transparent)" }}
        />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        {/* Eyebrow */}
        <div className="inline-flex items-center gap-3 mb-6">
          <div className="w-10 h-px bg-[#C8A63A]" />
          <span className="text-xs font-semibold tracking-[0.3em] uppercase text-[#C8A63A]" style={{ fontFamily: "'Inter', sans-serif" }}>
            Orientação Jurídica
          </span>
          <div className="w-10 h-px bg-[#C8A63A]" />
        </div>

        <h2
          className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Precisa de orientação jurídica especializada?
        </h2>
        <p className="text-white/70 text-base md:text-lg mb-10 max-w-2xl mx-auto leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
          Não espere o problema se agravar. Entre em contato agora e descubra como podemos proteger seus direitos com eficiência e ética.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center gap-3 px-8 py-4 rounded-md font-semibold text-base text-[#0A2472] transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            style={{ background: "linear-gradient(135deg, #C8A63A, #E6D18A)", fontFamily: "'Inter', sans-serif" }}
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-xl" />
            </span>
            Falar pelo WhatsApp
          </a>

          <button
            onClick={() => handleScroll("#contato")}
            className="hidden sm:flex items-center gap-3 px-8 py-4 rounded-md font-semibold text-base text-white border border-white/30 hover:border-white/70 hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-mail-send-line" />
            </span>
            Enviar mensagem
          </button>
        </div>

        {/* Trust indicators */}
        <div className="mt-14 flex flex-wrap items-center justify-center gap-8">
          {[
            { icon: "ri-shield-check-line", text: "Sigilo garantido" },
            { icon: "ri-time-line", text: "Resposta ágil" },
            { icon: "ri-award-line", text: "Equipe especializada" },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center text-[#E6D18A]">
                <i className={`${item.icon} text-base`} />
              </span>
              <span className="text-white/60 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
                {item.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
